import styled from 'styled-components';

export const MainWrapper = styled.main`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
`;

export const Main = styled.div`
  position: relative;
  z-index: 4;
`;